import { render, staticRenderFns } from "./ChoiseCut.vue?vue&type=template&id=01206959&scoped=true&"
import script from "./ChoiseCut.vue?vue&type=script&lang=js&"
export * from "./ChoiseCut.vue?vue&type=script&lang=js&"
import style0 from "./ChoiseCut.vue?vue&type=style&index=0&id=01206959&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01206959",
  null
  
)

export default component.exports